import './pages/new';
import './pages/edit';



// WEBPACK FOOTER //
// ./modules/admin/registries/index.js